// @flow

import React from 'react';
import DirectContactContainer from './directContact.container';
import type { ACFProps } from './types';

type Props = ACFProps;

const ACFDirectContact = ({
  contact_options,
  ...rest
}: Props) => (
  <DirectContactContainer
    acfContactOptions={contact_options || []}
    {...rest}
  />
);

export default ACFDirectContact;
